import { render } from "./Character.vue?vue&type=template&id=8e54b678"
import script from "./Character.vue?vue&type=script&lang=js"
export * from "./Character.vue?vue&type=script&lang=js"

import "./Character.vue?vue&type=style&index=0&id=8e54b678&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__